// Configuration type
interface Config {
  LOTUS_ANALYTICS_ENDPOINT: string;
  LOTUS_SEARCH_ENDPOINT: string;
  LOTUS_SEARCH_URL: string;
  CART_API_BASE: string;
  RECOMMENDATION_API_ENDPOINT: string;
  ONBOARDING_URL: string;
  SEARCH_CAROUSEL_MFE_URL: string;
  SESSION_API_URL: string;
  RECOMMENDATION_BRAND_CATEGORY: string;
  TOP_PICKS_RECOMMENDATION: boolean;
  OTHER_BOUGHT_RECOMMENDATION: boolean;
  MOBILE_SHOPPING_URL: string;
}

const onlyPublicConfig = {
  LOTUS_ANALYTICS_ENDPOINT:
    process.env.NEXT_PUBLIC_LOTUS_ANALYTICS_ENDPOINT || '',
  LOTUS_SEARCH_ENDPOINT: process.env.NEXT_PUBLIC_LOTUS_SEARCH_ENDPOINT || '',
  LOTUS_SEARCH_URL: process.env.NEXT_PUBLIC_APP_URL || '',
  MOBILE_SHOPPING_URL: process.env.NEXT_PUBLIC_MOBILE_SHOPPING_URL || '',
  CART_API_BASE: process.env.NEXT_PUBLIC_E_COMMERCE_URL || '',
  RECOMMENDATION_API_ENDPOINT:
    process.env.NEXT_PUBLIC_RECOMMENDATION_API_ENDPOINT || '',
  ONBOARDING_URL: process.env.NEXT_PUBLIC_ONBOARDING_URL || '',
  SEARCH_CAROUSEL_MFE_URL:
    process.env.NEXT_PUBLIC_SEARCH_CAROUSEL_MFE_URL || '',
  SESSION_API_URL: process.env.NEXT_PUBLIC_SESSION_API_URL || '',
  RECOMMENDATION_BRAND_CATEGORY:
    process.env.NEXT_PUBLIC_BRAND_CATEGORY_RECOMMENDATION_API_ENDPOINT || '',
  TOP_PICKS_RECOMMENDATION:
    process.env.NEXT_PUBLIC_ENABLED_TOPPICK_FOR_YOU_RECOMMENDATION === 'true',
  OTHER_BOUGHT_RECOMMENDATION:
    process.env.NEXT_PUBLIC_ENABLED_OTHER_BOUGHT_RECOMMENDATION === 'true',
};

const config: Config = {
  ...onlyPublicConfig,
};

export { config };
